

export class SalaryStructureDto implements ISalaryStructureDto {
    id!: number;
    structureName!: string | undefined;
    isActive!: boolean;

    constructor(data?: ISalaryStructureDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.structureName = _data["structureName"];
            this.isActive = _data["isActive"];
        }
    }

    static fromJS(data: any): SalaryStructureDto {
        data = typeof data === 'object' ? data : {};
        let result = new SalaryStructureDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["structureName"] = this.structureName;
        data["isActive"] = this.isActive;
        return data; 
    }
}

export interface ISalaryStructureDto {
    id: number;
    structureName: string | undefined;
    isActive: boolean;
}

